export default "__VITE_ASSET__ce6bf64a__"